import React from "react";
import "./index.scss";
import {strings} from "../../../strings/strings";

interface ScenarioHeaderProps {
    title: string
    description?: string
}

export const ScenarioHeader = (props: ScenarioHeaderProps) => {

    const {title, description} = props;

    return (
        <div className={"scenario-header"}>
            <div className={'scenario-title'}>
                <span className={'name'}>{title}</span>
                <span className={'description'}>{description || strings.scenarioHeaderDescription}</span>
            </div>
        </div>
    )
};